import request from '@/config/axios'

export const getIconList = () => request.get({ url: '/rental/home/icon/list' })
export const getIcon = (id: number) => request.get({ url: '/rental/home/icon/get', params: { id } })
export const createIcon = (data: any) => request.post({ url: '/rental/home/icon/create', data })
export const updateIcon = (data: any) => request.put({ url: '/rental/home/icon/update', data })
export const deleteIcon = (id: number) => request.delete({ url: '/rental/home/icon/delete', params: { id } })
